module.exports = __webpack_public_path__ + "img/wifi-fair.77de3c32.svg";